import * as React from 'react';

export default (
  <svg height="18" width="18" viewBox="0 0 18 18">
    <path d="M9 1C4.584 1 1 4.584 1 9s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 8.8c-.44 0-.8-.36-.8-.8V5.8c0-.44.36-.8.8-.8.44 0 .8.36.8.8V9c0 .44-.36.8-.8.8zm.8 3.2H8.2v-1.6h1.6V13z" />
  </svg>
);
